/* Auxiliar Bíblico, CM, frontend client.
 * Authenticated calls only. Backend enforces 20/day quota.
 */
import axios from "axios";
import { BACKEND_URL } from "./backendBase";

const client = axios.create({ baseURL: BACKEND_URL, withCredentials: true });

export const assistantApi = {
  usage: () => client.get("/api/assistant/usage").then((r) => r.data),
  ask: ({ question, session_id, mode }) =>
    client
      .post("/api/assistant/ask", {
        question,
        session_id: session_id || null,
        mode: mode || "default",
      })
      .then((r) => r.data),
  daily: () => client.get("/api/assistant/daily").then((r) => r.data),
  listSessions: () => client.get("/api/assistant/sessions").then((r) => r.data),
  listMessages: (id) =>
    client.get(`/api/assistant/sessions/${id}/messages`).then((r) => r.data),
  removeSession: (id) =>
    client.delete(`/api/assistant/sessions/${id}`).then((r) => r.data),
  weeklyPlan: () =>
    client.get("/api/assistant/weekly-plan").then((r) => r.data),
  generateWeeklyPlan: () =>
    client
      .post("/api/assistant/weekly-plan/generate", null, { timeout: 60_000 })
      .then((r) => r.data),
};
